// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function AndroidLogoIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M22 19.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM11.5 18a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM30 21v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2.859A14.172 14.172 0 0 1 6.425 10.84L3.293 7.707a1 1 0 1 1 1.415-1.414l3.27 3.27a13.929 13.929 0 0 1 16.068-.024l3.25-3.25a1 1 0 1 1 1.415 1.415l-3.108 3.109A13.906 13.906 0 0 1 30 21Zm-2 0A12 12 0 0 0 16 9h-.043C9.364 9.023 4 14.469 4 21.141V24h24v-3Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
